import { Flex } from "@chakra-ui/react";
import { pxToRem } from "../../../../utils/styles/size";

const InboxSubTaskToggle = () => {
  // TODO 추후에 subtask 시 추가될 예정
  return <Flex id="inbox-subtask-toggle" width={pxToRem(12)}></Flex>;
};

export default InboxSubTaskToggle;
